import validator from 'validator';

export function appValidateUrl(url: string): boolean {
    return validator.isURL(url);
}
